module.exports = __webpack_public_path__ + "media/images/home/step-catalog-001a6c2a051119312956ac0cb48a7d26.png";